// import formReducer, {
//   IFormState,
//   REDUCER_KEY_FORM,
// } from "@rentiohq/shared-frontend/dist/redux/form/form.reducer";
import {
  II18nState,
  REDUCER_KEY_I18N,
} from "@rentiohq/shared-frontend/dist/redux/i18n/i18n.reducer";
import persistI18nReducer from "@rentiohq/shared-frontend/dist/redux/i18n/i18n.reducerPersist";
import { combineReducers } from "redux";

export interface IRootState {
  // [REDUCER_KEY_FORM]: IFormState;
  [REDUCER_KEY_I18N]: II18nState;
}

export const reducers = combineReducers({
  // [REDUCER_KEY_FORM]: formReducer,
  [REDUCER_KEY_I18N]: persistI18nReducer,
});
